var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRejectCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4098_4613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4098_4613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0725 12L16.8441 9.22831C17.2395 8.83293 17.2395 8.19191 16.8441 7.79653C16.4487 7.40116 15.8078 7.40116 15.4124 7.79653L12.6407 10.5682L9.86904 7.79653C9.47367 7.40116 8.83265 7.40116 8.43728 7.79653C8.0419 8.19191 8.0419 8.83293 8.43728 9.22831L11.2089 12L8.43728 14.7717C8.0419 15.1671 8.0419 15.8081 8.43728 16.2035C8.63496 16.4011 8.89406 16.5 9.15315 16.5C9.41224 16.5 9.67135 16.4012 9.86902 16.2035L12.6407 13.4318L15.4124 16.2035C15.6101 16.4011 15.8691 16.5 16.1282 16.5C16.3873 16.5 16.6464 16.4012 16.8441 16.2035C17.2395 15.8081 17.2395 15.1671 16.8441 14.7717L14.0725 12Z",
    fill: "#9C4900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05729,
    y: 2.41667,
    width: 19.1667,
    height: 19.1667,
    rx: 3.75,
    stroke: "#9C4900",
    strokeWidth: 0.833333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejectCross);
export default __webpack_public_path__ + "static/media/ic_reject_cross.acde8cf7134a859f473953b143af0ec0.svg";
export { ForwardRef as ReactComponent };